import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

const fetchSharedRide = httpsCallable(functions, "getSharedRideStatus");

export default function AcompanharViagem() {
  const { token } = useParams();
  const [ride, setRide] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    const refresh = async () => {
      try {
        const result = await fetchSharedRide({ token });
        if (active) { setRide(result.data); setError(""); setLoading(false); }
      } catch (_) {
        if (active) { setError("Link inválido, expirado ou indisponível."); setLoading(false); }
      }
    };
    refresh();
    const timer = setInterval(refresh, 10000);
    return () => { active = false; clearInterval(timer); };
  }, [token]);
  const status = {
    pending: ["Buscando motorista…", "#6b7280"], accepted: ["Motorista a caminho", "#22c55e"],
    arrived: ["Motorista chegou", "#f59e0b"], in_progress: ["Em viagem", "#a855f7"],
    completion_pending: ["Finalizando com segurança…", "#3b82f6"], completed: ["Viagem concluída", "#22c55e"],
    cancelled: ["Corrida cancelada", "#ef4444"],
  }[ride?.status] || [ride?.status || "", "#6b7280"];
  if (loading) return <main className="shared-ride"><p>Carregando acompanhamento…</p><Style /></main>;
  if (error) return <main className="shared-ride"><h1>Link indisponível</h1><p>{error}</p><Style /></main>;
  return <main className="shared-ride">
    <section className="card header"><strong>ZUNO</strong><h1>{ride.passengerFirstName} está em uma corrida</h1><div className="status" style={{ color: status[1] }}>{status[0]}</div></section>
    <section className="card"><small>ROTA</small><p>● {ride.originLabel}</p><p>■ {ride.destinationLabel}</p></section>
    {ride.driver && <section className="card"><small>MOTORISTA</small><h2>{ride.driver.firstName}</h2><p>{ride.driver.vehicle}{ride.driver.plate ? ` · ${ride.driver.plate}` : ""}</p>{ride.driver.rating != null && <p>★ {Number(ride.driver.rating).toFixed(1)}</p>}{ride.driver.location && <p className="muted">Localização atualizada há poucos segundos.</p>}</section>}
    <p className="footer">A página atualiza automaticamente. O link expira por segurança.</p><Style />
  </main>;
}

function Style() { return <style>{`body{margin:0;background:#0a0e1a}.shared-ride{min-height:100vh;box-sizing:border-box;padding:32px 16px;color:#fff;font-family:system-ui,sans-serif;display:flex;flex-direction:column;gap:14px}.card{width:min(560px,100%);box-sizing:border-box;margin:0 auto;padding:20px;border:1px solid rgba(255,255,255,.09);border-radius:18px;background:rgba(255,255,255,.045)}.header{background:linear-gradient(135deg,#0d1527,#1a0a2e)}h1{font-size:22px;margin:12px 0}h2{font-size:18px;margin:10px 0 4px}.status{font-weight:800}.card small,.muted,.footer{color:rgba(255,255,255,.5)}.card p{line-height:1.45}.footer{text-align:center;font-size:12px}`}</style>; }
